// extracted by mini-css-extract-plugin
export const root = "profile-module--root--7heSG";
export const paper = "profile-module--paper--cL6FK";
export const container = "profile-module--container--SveMn";
export const stat = "profile-module--stat--0gToX";
export const table = "profile-module--table---CEsn";